<template>
  <div class="product-flag">
    <icon :icon="icon" size="s"></icon>
    <span>{{ label }}</span>
  </div>
</template>

<script>
import Icon from '../../../vue-elements/icon/Icon.vue';
export default {
  components: { Icon },
  props: {
    icon: {
      type: String,
      default: 'x-fa-trophy',
    },
    label: {
      type: String,
      default: 'Goedkoopste keuze',
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
@use 'assets/scss/_helpers/typography';
@use 'assets/scss/_variables/colors';
.product-flag {
  @include typography.paragraph-14;

  display: inline-flex;
  align-items: center;
  padding: 10px 16px;
  border-radius: 8px 0 8px 0;
  color: colors.$link-base-active;
  border: 1px solid colors.$border-base;
  background-color: colors.$background-default;
  // color: #0a710a;

  // background: #C5F6C5;
  // border: 1px solid #0a710a;


  font-weight: 600;

  .icon-element {
    background-color: currentColor;
    margin-right: 8px;
  }
}
</style>
